// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___511012da0eae02332e5","cls2":"Comments-cls2___ab77f49ba226980f50a Comments-cls1___511012da0eae02332e5"};